import React from 'react';
import moment from 'moment';

import { Badge, Button, } from 'react-bootstrap'

import './styles.css'

import { isServerDataOutDated, ServerStatus, } from '../../entities/server';


const FIELDS = [
  'squid',
  'fw',
  'samba',
  'http',
  'vpn',
  'maquina',
  'rede',
  'dhcp',
  'dns',
  'mysql',
  'backup',
  'disco',
  'memoria',
  'bkp',
];


const CorpoMon = ({ data }) => {
  const lastUpdateStatusColor = isServerDataOutDated(data.data) ? '#F73944' : '#31D9A6';


  return (
    <tbody>
      <tr>
        <td className="TitleString">
          {data.fantasia}
        </td>
        <td className="TitleString">
          {data.nome}
        </td>

        {
          FIELDS
            .map((field) => {
              let externElClass = 'badgeExternGray';
              let internElClass = 'badgeInternGray';

              const status = data[field];
              if (ServerStatus.ERROR === status) {
                externElClass = 'badgeExternRed';
                internElClass = 'badgeInternRed';
              } else if (ServerStatus.ACTIVE === status) {
                externElClass = 'badgeExternGreen';
                internElClass = 'badgeInternGreen';
              }

              return (
                <td key={field}>
                  <div className="boxBadge">
                    <div className={externElClass}>
                      <div className={internElClass}></div>
                    </div>
                  </div>
                </td>
              );
            })
        }

        <td>
          <div className="boxBadge">
            <Badge
              style={{
                color: lastUpdateStatusColor,
              }}
            >
              {moment(data.data).format('YYYY-MM-DDTHH:mm:SS')}
            </Badge>
          </div>
        </td>

        <td>
          {data.ip}
        </td>

        <td>
          <Button
            href={`https://${data.ip}:8181/info`}
            size="sm"
            variant="warning"
            styles={{
              marginLeft: '1%',
            }}
          >
            FW
          </Button>
        </td>

        <td>
          <Button
            href={`https://${data.ip}:8181/ip`}
            size="sm"
            variant="dark"
          >
            IP
          </Button>
        </td>
      </tr>
    </tbody>
  )
}

export default CorpoMon;
